import { gameItemInfo } from './gameCatalog';
/** 素材や色を表す語。長いものから順に照合する。 */
const materials: Array<[string, string]> = [
  ['light_blue', '空色'],
  ['light_gray', '薄灰色'],
  ['dark_oak', 'ダークオーク'],
  ['stripped_oak', '樹皮を剥いだオーク'],
  ['mossy_cobblestone', '苔むした丸石'],
  ['mossy_stone_brick', '苔むした石レンガ'],
  ['cracked_stone_brick', 'ひび割れた石レンガ'],
  ['chiseled_stone_brick', '模様入りの石レンガ'],
  ['polished_blackstone_brick', '磨かれたブラックストーンレンガ'],
  ['polished_blackstone', '磨かれたブラックストーン'],
  ['polished_deepslate', '磨かれた深層岩'],
  ['cobbled_deepslate', '深層岩の丸石'],
  ['deepslate_brick', '深層岩レンガ'],
  ['deepslate_tile', '深層岩タイル'],
  ['polished_andesite', '磨かれた安山岩'],
  ['polished_diorite', '磨かれた閃緑岩'],
  ['polished_granite', '磨かれた花崗岩'],
  ['smooth_sandstone', 'なめらかな砂岩'],
  ['smooth_stone', 'なめらかな石'],
  ['smooth_quartz', 'なめらかなクォーツ'],
  ['red_sandstone', '赤い砂岩'],
  ['end_stone_brick', 'エンドストーンレンガ'],
  ['nether_brick', 'ネザーレンガ'],
  ['stone_brick', '石レンガ'],
  ['mud_brick', '泥レンガ'],
  ['prismarine_brick', 'プリズマリンレンガ'],
  ['dark_prismarine', 'ダークプリズマリン'],
  ['cobblestone', '丸石'],
  ['blackstone', 'ブラックストーン'],
  ['sandstone', '砂岩'],
  ['deepslate', '深層岩'],
  ['andesite', '安山岩'],
  ['diorite', '閃緑岩'],
  ['granite', '花崗岩'],
  ['calcite', '方解石'],
  ['basalt', '玄武岩'],
  ['netherrack', 'ネザーラック'],
  ['end_stone', 'エンドストーン'],
  ['prismarine', 'プリズマリン'],
  ['purpur', 'プルプァ'],
  ['quartz', 'クォーツ'],
  ['obsidian', '黒曜石'],
  ['bedrock', '岩盤'],
  ['gravel', '砂利'],
  ['terracotta', 'テラコッタ'],
  ['concrete', 'コンクリート'],
  ['glass', 'ガラス'],
  ['bricks', 'レンガ'],
  ['brick', 'レンガ'],
  ['stone', '石'],
  ['tuff', '凝灰岩'],
  ['resin', 'レジン'],
  ['sulfur', '硫黄'],
  ['cinnabar', '辰砂'],
  ['pale_oak', '淡いオーク'],
  ['mangrove', 'マングローブ'],
  ['crimson', '真紅'],
  ['warped', '歪んだ'],
  ['spruce', 'トウヒ'],
  ['bamboo', '竹'],
  ['cherry', 'サクラ'],
  ['acacia', 'アカシア'],
  ['jungle', 'ジャングル'],
  ['birch', 'シラカバ'],
  ['oak', 'オーク'],
  ['iron', '鉄'],
  ['gold', '金'],
  ['diamond', 'ダイヤモンド'],
  ['emerald', 'エメラルド'],
  ['lapis', 'ラピスラズリ'],
  ['redstone', 'レッドストーン'],
  ['netherite', 'ネザライト'],
  ['copper', '銅'],
  ['amethyst', 'アメジスト'],
  ['coal', '石炭'],
  ['magenta', '赤紫色'],
  ['orange', '橙色'],
  ['yellow', '黄色'],
  ['purple', '紫色'],
  ['brown', '茶色'],
  ['green', '緑色'],
  ['white', '白色'],
  ['black', '黒色'],
  ['cyan', '青緑色'],
  ['gray', '灰色'],
  ['lime', '黄緑色'],
  ['pink', '桃色'],
  ['blue', '青色'],
  ['red', '赤色'],
  ['snow', '雪'],
  ['ice', '氷'],
  ['hay', '干草'],
  ['bone', '骨'],
  ['dirt', '土'],
  ['sand', '砂'],
  ['mud', '泥'],
  ['clay', '粘土'],
  ['moss', '苔'],
];

/** 素材の後ろに付く形状の語。 */
const forms: Array<[string, string]> = [
  ['_stained_glass_pane', 'の色付きガラス板'],
  ['_stained_glass', 'の色付きガラス'],
  ['_glazed_terracotta', 'の彩釉テラコッタ'],
  ['_concrete_powder', 'のコンクリートパウダー'],
  ['_pressure_plate', 'の感圧板'],
  ['_fence_gate', 'のフェンスゲート'],
  ['_trapdoor', 'のトラップドア'],
  ['_shulker_box', 'のシュルカーボックス'],
  ['_planks', 'の板材'],
  ['_stairs', 'の階段'],
  ['_button', 'のボタン'],
  ['_carpet', 'のカーペット'],
  ['_hyphae', 'の菌糸'],
  ['_leaves', 'の葉'],
  ['_fence', 'のフェンス'],
  ['_slab', 'のハーフブロック'],
  ['_door', 'のドア'],
  ['_sign', 'の看板'],
  ['_wall', 'の塀'],
  ['_pane', '板'],
  ['_wool', 'の羊毛'],
  ['_pillar', 'の柱'],
  ['_stem', 'の幹'],
  ['_log', 'の原木'],
  ['_wood', 'の木'],
  ['_bed', 'のベッド'],
  ['_ore', '鉱石'],
  ['_block', 'ブロック'],
  ['_bars', '格子'],
  ['_rod', 'の棒'],
];

/** 語の組み合わせでは表せないブロック。 */
const exact: Record<string, string> = {
  air: '空気',
  grass_block: '草ブロック',
  dirt_path: '土の道',
  coarse_dirt: '粗い土',
  rooted_dirt: '根付いた土',
  podzol: 'ポドゾル',
  mycelium: '菌糸',
  farmland: '耕地',
  water: '水',
  lava: '溶岩',
  glass: 'ガラス',
  glass_pane: 'ガラス板',
  iron_bars: '鉄格子',
  torch: '松明',
  wall_torch: '壁付けの松明',
  soul_torch: '魂の松明',
  lantern: 'ランタン',
  soul_lantern: '魂のランタン',
  chain: '鎖',
  glowstone: 'グロウストーン',
  sea_lantern: 'シーランタン',
  shroomlight: 'シュルームライト',
  redstone_lamp: 'レッドストーンランプ',
  campfire: '焚き火',
  bookshelf: '本棚',
  chiseled_bookshelf: '模様入りの本棚',
  crafting_table: '作業台',
  furnace: 'かまど',
  blast_furnace: '溶鉱炉',
  smoker: '燻製器',
  smithing_table: '鍛冶台',
  fletching_table: '矢細工台',
  cartography_table: '製図台',
  loom: '機織り機',
  barrel: '樽',
  chest: 'チェスト',
  trapped_chest: 'トラップチェスト',
  ender_chest: 'エンダーチェスト',
  lectern: '書見台',
  composter: 'コンポスター',
  cauldron: '大釜',
  anvil: '金床',
  grindstone: '砥石',
  stonecutter: '石切台',
  enchanting_table: 'エンチャントテーブル',
  brewing_stand: '醸造台',
  beacon: 'ビーコン',
  conduit: 'コンジット',
  jukebox: 'ジュークボックス',
  note_block: '音符ブロック',
  bell: 'ベル',
  redstone_wire: 'レッドストーンのこな',
  redstone_torch: 'レッドストーントーチ',
  redstone_wall_torch: '壁付けのレッドストーントーチ',
  redstone_block: 'レッドストーンブロック',
  repeater: 'レッドストーンリピーター',
  comparator: 'レッドストーンコンパレーター',
  piston: 'ピストン',
  sticky_piston: '粘着ピストン',
  piston_head: 'ピストンの腕',
  sticky_piston_head: '粘着ピストンの腕',
  dispenser: 'ディスペンサー',
  command_block: 'コマンドブロック',
  repeating_command_block: 'リピートコマンドブロック',
  chain_command_block: 'チェーンコマンドブロック',
  dropper: 'ドロッパー',
  observer: 'オブザーバー',
  hopper: 'ホッパー',
  lever: 'レバー',
  tripwire: '糸',
  tripwire_hook: 'トリップワイヤーフック',
  daylight_detector: '日照センサー',
  target: 'ターゲット',
  rail: 'レール',
  powered_rail: 'パワードレール',
  detector_rail: 'ディテクターレール',
  activator_rail: 'アクティベーターレール',
  ladder: 'はしご',
  scaffolding: '足場',
  bricks: 'レンガ',
  stone_bricks: '石レンガ',
  nether_bricks: 'ネザーレンガ',
  mud_bricks: '泥レンガ',
  end_stone_bricks: 'エンドストーンレンガ',
  hay_block: '干草の俵',
  bone_block: '骨ブロック',
  slime_block: 'スライムブロック',
  honey_block: 'ハチミツブロック',
  sponge: 'スポンジ',
  cobweb: 'クモの巣',
  tnt: 'TNT',
  pumpkin: 'カボチャ',
  carved_pumpkin: 'くり抜かれたカボチャ',
  jack_o_lantern: 'ジャック・オ・ランタン',
  melon: 'スイカ',
  cake: 'ケーキ',
  snow: '雪',
  snow_block: '雪ブロック',
  ice: '氷',
  packed_ice: '氷塊',
  blue_ice: '青氷',
  vine: 'ツタ',
  lily_pad: 'スイレンの葉',
  short_grass: '草',
  grass: '草',
  tall_grass: '背の高い草',
  fern: 'シダ',
  large_fern: '大きなシダ',
  dead_bush: '枯れ木',
  sugar_cane: 'サトウキビ',
  bamboo: '竹',
  cactus: 'サボテン',
  poppy: 'ポピー',
  dandelion: 'タンポポ',
  blue_orchid: 'ヒスイラン',
  allium: 'アリウム',
  azure_bluet: 'ヒナソウ',
  oxeye_daisy: 'フランスギク',
  cornflower: 'ヤグルマギク',
  lily_of_the_valley: 'スズラン',
  wither_rose: 'ウィザーローズ',
  brown_mushroom: '茶キノコ',
  red_mushroom: '赤キノコ',
  moss_block: '苔ブロック',
  mud: '泥',
  clay: '粘土',
  gravel: '砂利',
  sand: '砂',
  red_sand: '赤い砂',
  soul_sand: 'ソウルサンド',
  soul_soil: 'ソウルソイル',
  magma_block: 'マグマブロック',
  netherrack: 'ネザーラック',
  bedrock: '岩盤',
  spawner: 'スポナー',
  crafter: 'クラフター',
  trial_spawner: 'トライアルスポナー',
  vault: '金庫',
  heavy_core: 'ヘビーコア',
  copper_bulb: '銅の電球',
  creaking_heart: 'クリーキングの心臓',
  pale_moss_block: '淡い苔ブロック',
  pale_hanging_moss: '垂れ下がる淡い苔',
  bush: '低木',
  firefly_bush: 'ホタルの低木',
  cactus_flower: 'サボテンの花',
  leaf_litter: '落ち葉',
  wildflowers: '野花',
  short_dry_grass: '短い枯れ草',
  tall_dry_grass: '背の高い枯れ草',
  dried_ghast: '乾いたガスト',
  sulfur_spike: '硫黄のスパイク',
  barrier: 'バリアブロック',
  structure_block: 'ストラクチャーブロック',
  structure_void: '構造空間',
};

const sortedMaterials = [...materials].sort((left, right) => right[0].length - left[0].length);

/** `__proto__`や`constructor`という名前で、プロトタイプ側の値を拾わないようにする。 */
function exactLabel(name: string): string | undefined {
  return Object.hasOwn(exact, name) ? exact[name] : undefined;
}

export function stripNamespace(name: string): string {
  const separator = name.indexOf(':');
  return (separator >= 0 ? name.slice(separator + 1) : name).toLowerCase();
}

/** `deepslate_diamond` のような複合語を、既知の語だけで最後まで置き換えられたときに訳す。 */
function translateBase(base: string): string | undefined {
  const known = exactLabel(base);
  if (known) return known;
  const direct = materials.find(([key]) => key === base);
  if (direct) return direct[1];

  let rest = base;
  let translated = '';
  while (rest.length > 0) {
    const match = sortedMaterials.find(([key]) => rest === key || rest.startsWith(`${key}_`));
    if (!match) return undefined;
    translated += match[1];
    rest = rest.slice(match[0].length).replace(/^_/, '');
  }
  return translated;
}

/**
 * ブロックIDを日本語の呼び名にする。素材語と形状語の組み合わせで解決し、
 * どちらにも当てはまらないものはIDをそのまま返す。
 */
export function blockLabel(rawName: string): string {
  const gameName = gameItemInfo(rawName)?.name;
  if (gameName) return gameName;
  const name = stripNamespace(rawName);
  const known = exactLabel(name);
  if (known) return known;

  const peeled = name.startsWith('stripped_');
  const stripped = peeled ? name.slice('stripped_'.length) : name;
  const prefix = peeled ? '樹皮を剥いだ' : '';

  const form = forms.find(([suffix]) => stripped.endsWith(suffix) && stripped.length > suffix.length);
  if (form) {
    const translated = translateBase(stripped.slice(0, -form[0].length));
    if (translated === undefined) return rawName;
    // 「歪んだ」のような形容詞には「の」を挟まない。
    const suffix = translated.endsWith('だ') ? form[1].replace(/^の/, '') : form[1];
    return `${prefix}${translated}${suffix}`;
  }

  const translated = translateBase(stripped);
  return translated === undefined ? rawName : `${prefix}${translated}`;
}
